module.exports = __webpack_public_path__ + "media/images/flags/1x1/tto-43caabbda8c19ec0ed56a80546e41a16.svg";